import React from "react";
import { Sparkles, Target, Wand2, MessageSquare } from "lucide-react";

const benefits = [
  {
    icon: Target,
    title: "Mi sistema de Ventas Virales",
    desc: "El mapa exacto del método con el que pasé de 100K a +950K seguidores en 5 meses.",
  },
  {
    icon: Sparkles,
    title: "Contenido que vende de verdad",
    desc: "Cómo creo cada pieza para que atraiga clientes reales, no solo likes vacíos.",
  },
  {
    icon: Wand2,
    title: "IA aplicada a redes",
    desc: "Los atajos con IA que uso a diario para ahorrar horas y multiplicar mi alcance.",
  },
  {
    icon: MessageSquare,
    title: "Q&A en directo conmigo",
    desc: "Resuelvo tus dudas en tiempo real con casos reales de mis alumnos.",
  },
];

export default function Benefits() {
  return (
    <section className="section section-dark" style={{ paddingTop: "4rem" }}>
      <div className="container">
        <div
          className="eyebrow-yellow"
          style={{ textAlign: "center", marginBottom: "0.8rem" }}
        >
          Qué vas a aprender
        </div>
        <h2
          className="h2-section"
          style={{
            textAlign: "center",
            maxWidth: 900,
            margin: "0 auto 2.5rem",
          }}
        >
          Una clase para dejar de improvisar
          <br />
          y empezar a{" "}
          <span className="serif-italic hl-purple">vender con método</span>.
        </h2>

        <div className="grid-4">
          {benefits.map((b, i) => {
            const Icon = b.icon;
            return (
              <div key={i} className="card">
                <div
                  style={{
                    width: 44,
                    height: 44,
                    borderRadius: 12,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "rgba(217,255,0,0.1)",
                    border: "1px solid rgba(217,255,0,0.35)",
                    marginBottom: "1rem",
                  }}
                >
                  <Icon size={22} color="#d9ff00" strokeWidth={2} />
                </div>
                <div
                  className="h3-block"
                  style={{ fontSize: "1.1rem", marginBottom: "0.5rem" }}
                >
                  {b.title}
                </div>
                <p
                  style={{
                    color: "#a8a8a8",
                    fontSize: "0.92rem",
                    lineHeight: 1.55,
                    margin: 0,
                  }}
                >
                  {b.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
